import axiosInstance from "./axiosInstance";

const getClientDetails = async (clientId: string) =>
  axiosInstance.get(`/v3/${clientId}`);

export default getClientDetails;
